import React, { Component } from 'react';
import PageHelmet from './Helmet';
import ContactThree from './ContactThree';
import BrandTwo from './BrandTwo';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import { GiTicket, GiPriceTag } from 'react-icons/gi';
import { FiCheck, FiLock } from 'react-icons/fi';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import Header from '../../Layout/Main/header/Header';
import Footer from '../../Layout/Main/footer/FooterTwo';
import distance from 'google-distance-matrix';
import axios from 'axios';
const AnyReactComponent = ({ text }) => <div>{text}</div>;

class ThankYou extends Component {
	state = {
		selectedDate: new Date('2014-08-18T21:11:54'),
		finalCost: 0,
		clientId: '',
	};
	componentDidMount = async () => {
		//     setTimeout(() => {
		window.scrollTo(0, 0);
		console.log('HELLLOOW');
		//     }, 600);

		// setTimeout(() => {
		const data = this.props.location.state.data;
		console.log(data);
		this.setState({
			clientId: data.clientId,
		});
		console.log(data);
		let address, destination;
		if (data.movingFromDetails !== '' && data.movingToDetails !== '') {
			address = 'Toronto, ON, CA';
			destination = 'Vancouver, ON, CA';

			address = data.movingFromDetails.city;
			destination = data.movingToDetails.city;
		}

		let key = 'AIzaSyAe-RvE9UpwF-SNkKvlpt4YpjOgDfaUCpQ';
		let url = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;

		try {
			let destinationTime = await axios.get(url);
			// console.log(destinationTime);
			if (destinationTime.data.status === 'OK') {
				let duration = destinationTime.data.rows[0].elements[0].duration;
				let T = duration.text.split(' ');
				console.log(T[1]);
				if (T[1] === 'day') {
					let t = T[4] !== null && T[4] > 30 ? 1 : 0;
					T = parseInt(T[0]) * 24 + parseInt(T[2]) + parseInt(t);
				} else if (T[1] === 'hours') {
					let t = T[1] !== null && T[2] > 30 ? 1 : 0;
					T = parseInt(T[0]) + parseInt(t);
				} else {
					let t = parseInt(T[1]) !== null && parseInt(T[1]) > 30 ? 1 : 0;
				}
				console.log(T);
				let wareFromHouse = 'address';
				let urlFromWareHouse = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;
				let wareHouseFromDestinaiton = await axios.get(urlFromWareHouse);
				let wTi = wareHouseFromDestinaiton.data.rows[0].elements[0].duration;
				let Ti = wTi.text.split(' ');
				if (Ti[1] === 'day') {
					let t = Ti[4] !== null && Ti[4] > 30 ? 1 : 0;
					Ti = parseInt(Ti[0]) * 24 + parseInt(Ti[2]) + parseInt(t);
				} else if (Ti[1] === 'hours') {
					let t = Ti[1] !== null && Ti[2] > 30 ? 1 : 0;
					Ti = parseInt(Ti[0]) + parseInt(t);
				} else {
					let t = parseInt(Ti[1]) !== null && parseInt(Ti[1]) > 30 ? 1 : 0;
				}
				Ti = 1;

				let wareToHouse = 'address';
				let urlwareToHouse = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${address}&destinations=${destination}&mode=driving&units=imperial&language=en&avoid=&key=${key}`;
				let wareHouseToDestinaiton = await axios.get(urlwareToHouse);
				let wTf = wareHouseToDestinaiton.data.rows[0].elements[0].duration;
				let Tf = wTf.text.split(' ');
				if (Tf[1] === 'day') {
					let t = Ti[4] !== null && Tf[4] > 30 ? 1 : 0;
					Tf = parseInt(Tf[0]) * 24 + parseInt(Tf[2]) + parseInt(t);
				} else if (Tf[1] === 'hours') {
					let t = Tf[1] !== null && Tf[2] > 30 ? 1 : 0;
					Tf = parseInt(Tf[0]) + parseInt(t);
				} else {
					let t = parseInt(Tf[1]) !== null && parseInt(Tf[1]) > 30 ? 1 : 0;
				}
				Tf = 1;

				let Ts = 0;
				switch (data.sizeOfCurrentHome) {
					case '1 Bedroom Apartment':
						// based on condition 3 - 4
						Ts = 4;
						break;
					case '2 Bedroom Apartment':
						// based on condition 5 - 6
						Ts = 5;
						break;
					case '3 Bedroom Apartment':
						// based on condition 7 - 8
						Ts = 8;
						break;
					case '4 Bedroom Apartment':
						// based on condition 8 - 10
						Ts = 10;
						break;
					case '5 Bedroom Apartment':
						// based on condition 10+
						Ts = 12;
						break;
				}
				let tn = (T + Ti + Tf + Ts) * 130;
				let finalCost = parseInt(tn) + (parseInt(tn) / 100) * 12;
				console.log(finalCost.toFixed(2));
				this.setState({
					finalCost: finalCost,
				});
			}
		} catch (err) {
			console.log(err);
		}
		
	};
	static defaultProps = {
		center: {
			lat: 59.95,
			lng: 30.33,
		},
		zoom: 11,
	};

	handleDateChange = date => {
		this.setState({ selectedDate: date });
	};

	render() {
		return (
			<React.Fragment>
				<PageHelmet pageTitle='Final Cost' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />

				{/* Start Breadcrump Area */}
				<div className='rn-page-title-area pt--120 pb--190 bg_image bg_image--17' data-black-overlay='6'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-12'>
								<div className='rn-page-title text-center pt--100'>
									<h2 className='title theme-gradient'>Final Cost</h2>
									{/* <p>Contrary to popular belief, Lorem Ipsum is not simply random text. </p> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Breadcrump Area */}

				{/* Start Contact Top Area  */}
				<div className='rn-contact-top-area'>
					<div className='container'>
						<div className='row'>
							{/* Start Single Address  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact With Phone Number</h4>
                                        <p><a href="tel:+057 254 365 456">+057 254 365 456</a></p>
                                        <p><a href="tel:+856 325 652 984">+856 325 652 984</a></p>
                                    </div>
                                </div>
                            </div> */}
							{/* End Single Address  */}

							{/* Start Single Address  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Email Address</h4>
                                        <p><a href="mailto:admin@gmail.com">admin@gmail.com</a></p>
                                        <p><a href="mailto:example@gmail.com">example@gmail.com</a></p>
                                    </div>
                                </div>
                            </div> */}
							{/* End Single Address  */}

							{/* Start Single Address  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Location</h4>
                                        <p>5678 Bangla Main Road, cities 580 <br /> GBnagla, example 54786</p>
                                    </div>
                                </div>
                            </div> */}
							{/* End Single Address  */}
						</div>
					</div>
				</div>
				{/* End Contact Top Area  */}

				{/* Start Contact Page Area  */}
				<div className='rn-contact-page ptb--120 bg_color--1'>
					<div className='container'>
						<div className='row'>
							<h3>Based on your moving list the total for your move is:</h3>
							<div className='col-lg-9 col-md-6 col-sm-6 col-12'>
								<div className='row'>
									{/* Start Single Address  */}
									<div className='col-lg-4 col-md-6 col-sm-6 col-12'>
										<div className='rn-address'>
											<div className='icon'>
												<FiLock />
											</div>
											<div className='inner'>
												<p> $ {this.state.finalCost}</p>
											</div>
										</div>
										<h5 className='title'>Lock this Price Now</h5>
									</div>
									{/* End Single Address  */}

									{/* Start Single Address  */}
									{/* <div className='col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50'>
										<div className='rn-address'>
											<div className='icon'>
												<GiTicket />
											</div>
											<div className='inner'>
												<p>$114.75</p>
											</div>
										</div>
										<h5 className='title'>Reserved Now With Only 25%</h5>
									</div> */}
									{/* End Single Address  */}

									{/* Start Single Address  */}
									{/* <div className='col-lg-4 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50'>
										<div className='rn-address'>
											<div className='icon'>
												<GiPriceTag />
											</div>
											<div className='inner'>
												<p>$344.25</p>
											</div>
										</div>
										<h5 className='title'>Remaining balance after moving is completed</h5>
									</div> */}
									{/* End Single Address  */}
								</div>
								<div className='row'>
									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											BOOK NOW! with only 25% of the total
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											Our system will find a company to make your move
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											You will receive an email with up to 5 moving companies ready to make your move
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											Once you have received the email just select one company from the list
										</p>
									</div>

									<div className='col-lg-1' style={{ paddingRight: '0', marginBottom: '3vh' }}>
										<div className='check' style={{ fontSize: '5vh', textAlign: 'right' }}>
											<FiCheck />
										</div>
									</div>
									<div className='col-lg-11'>
										<p className='check-text' style={{ marginTop: '1.5vh' }}>
											The moving company will contact you for final details
										</p>
									</div>
								</div>
							</div>
							<div className='col-lg-3'>
								<div className='row'>
									<div className='col-lg-12 mb-3'>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
												margin='normal'
												id='date-picker-dialog'
												label='Date picker'
												format='MM/dd/yyyy'
												value={this.state.selectedDate}
												onChange={this.handleDateChange}
												KeyboardButtonProps={{
													'aria-label': 'change date',
												}}
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div className='col-lg-12'>
										<div className='bookNow text-center'>
											<RouterLink className='rn-btn' to={{ pathname: '/paymentdetails', state: { amount: this.state.finalCost, clientId: this.state.client } }} style={{ height: '50px', width: '30vh', paddingLeft: '25px', paddingTop: '5px' }}>
												<span style={{ fontSize: '17px' }}>BOOK NOW</span>
											</RouterLink>
											<p>Get an EXTRA 5% Off</p>
										</div>
									</div>
									<div className='col-lg-12 mt-3'></div>
									<div className='col-lg-12'>
										<div className='SaveNow text-center'>
											<a className='rn-btn' href='/movedetails' style={{ height: '50px', width: '40vh', paddingLeft: '10px', paddingRight: '10px', paddingTop: '5px' }}>
												<span style={{ fontSize: '17px' }}>SAVE AND BOOK LATER</span>
											</a>
											<p>Save your info and book later</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* End Contact Top Area  */}

				{/* End Contact Page Area  */}

				{/* Start Contact Map  */}
				{/* <div className="rn-contact-map-area position-relative">
                    <div style={{ height: '650px', width: '100%' }}>
                        <GoogleMapReact
                        defaultCenter={this.props.center}
                        defaultZoom={this.props.zoom}
                        >
                        <AnyReactComponent
                            lat={59.955413}
                            lng={30.337844}
                            text="My Marker"
                        />
                        </GoogleMapReact>
                    </div>
                </div> */}
				{/* End Contact Map  */}

				{/* Start Brand Area */}
				{/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
				{/* End Brand Area */}

				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default withRouter(ThankYou);
